var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

$(".size_selector p").on("click", function (e) {
  e.preventDefault();
  $(this).parent().find(".active").removeClass("active");
  $(this).addClass("active");
});

$("img.arrow-up").on("click", function (e) {
  e.preventDefault();
  let current_val = parseInt(
    $(this).closest(".product_quantity").find("span").html()
  );
  $(this)
    .closest(".product_quantity")
    .find("span")
    .html(current_val + 1);
});

$("img.arrow-down").on("click", function (e) {
  e.preventDefault();
  let current_val = parseInt(
    $(this).closest(".product_quantity").find("span").html()
  );
  if (current_val > 1) {
    $(this)
      .closest(".product_quantity")
      .find("span")
      .html(current_val - 1);
  }
});

$('.S_selector.size_selector p').on('click', function(){
  var variant_id = $(this).data('variant')
  $('[name="id"]').val(variant_id)
})


$(".add_to_cart button").on("click", function (e) {
  e.preventDefault();
  console.log(
    $(this).closest(".product_section").find(".size_selector p.active")
  );
  let var_id = $(this)
    .closest(".product_section")
    .find(".size_selector p.active")
    .data("variant");
  let qty = parseInt(
    $(this).closest(".product_section").find(".product_quantity p span").html()
  );
  addItem(var_id, qty);
});

function addItem(var_id, qty) {
  CartJS.addItem(
    var_id,
    qty,
    {},
    {
      success: function (data, textStatus, jqXHR) {
        console.log("Added!");
        console.log(data);
      },
      error: function (jqXHR, textStatus, errorThrown) {
        console.log("Error: " + errorThrown + "!");
      },
    }
  );
}

if ($(".slider .slide").length > 1) {
  $(".slider")
    .not(".slick-initialized")
    .slick({
      slidesToShow:
        $(".product_section.slide").length > 3
          ? 4
          : $(".product_section.slide").length,
      dots: false,
      centerMode: true,
      autoplay: true,
      prevArrow:
        '<button class="slide-arrow prev-arrow"><i class="fa fa-arrow-right"></i></button>',
      nextArrow:
        '<button class="slide-arrow next-arrow"><i class="fa fa-arrow-left"></i></button>',
      responsive: [
        {
          breakpoint: 1501,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 1101,
          settings: {
            slidesToShow: 2,
            centerMode: false,
          },
        },
        {
          breakpoint: 627,
          settings: {
            slidesToShow: 1,
            centerMode: false,
          },
        },
      ],
    });
}

if($('.product_img img').length > 1 && $('[action="/cart/add"] .product_img').length > 0){
    $('[action="/cart/add"] .product_img')
    .not(".slick-initialized")
    .slick({
      slidesToShow:1,
      dots: false,
      centerMode: false,
      autoplay: false,
      prevArrow:
        '<button type="button" class="slide-arrow prev-arrow"><i class="fa fa-chevron-right"></i></button>',
      nextArrow:
        '<button type="button" class="slide-arrow next-arrow"><i class="fa fa-chevron-left"></i></button>',
      responsive: [
        {
          breakpoint: 1501,
          settings: {
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 1101,
          settings: {
            slidesToShow: 1,
            centerMode: false,
          },
        },
        {
          breakpoint: 627,
          settings: {
            slidesToShow: 1,
            centerMode: false,
          },
        },
      ],
    });
}

if($('.product_img img').length > 1 && window.location.pathname == '/'){
   setTimeout(function(){ 
    $('.product_img')
    .not(".slick-initialized")
    .slick({
      slidesToShow:1,
      dots: false,
      centerMode: false,
      autoplay: false,
      prevArrow:
        '<button type="button" class="slide-arrow prev-arrow"><i class="fa fa-chevron-right"></i></button>',
      nextArrow:
        '<button type="button" class="slide-arrow next-arrow"><i class="fa fa-chevron-left"></i></button>',
      responsive: [
        {
          breakpoint: 1501,
          settings: {
            slidesToShow: 1,
          },
        },
        {
          breakpoint: 1101,
          settings: {
            slidesToShow: 1,
            centerMode: false,
          },
        },
        {
          breakpoint: 627,
          settings: {
            slidesToShow: 1,
            centerMode: false,
          },
        },
      ],
    });
   }, 1000)
}

function buildCart(cart) {
  var itemsLoop = "";
  cart.items.forEach((x) => {
    itemsLoop =
      itemsLoop +
      `
    <div class="product_container">
      <div class="product_img_cont">
        <img src="${x.image}" alt="product_container 1">
      </div>
      <div class="product_detail">
        <h3>${x.product_title}</h3>
        <h3>${x.variant_title?x.variant_title:''}</h3>
        <h3 style="margin-bottom: 0px;">${Shopify.formatMoney(
          x.final_price,
          "£{{amount}}"
        )}</h3>
        <div class="qty_cont">
          <h3>QUANTITY - <span>${x.quantity}</span></h3>
          <div class="qty_arrow_cont">
            <img class="arrow-up" data-id="${
              x.id
            }" src="https://cdn.shopify.com/s/files/1/0530/3635/1665/files/up_arrow.png" alt="" width="26">
            <img class="arrow-down" data-id="${
              x.id
            }" src="https://cdn.shopify.com/s/files/1/0530/3635/1665/files/down_arrow.png" alt="" width="26" style="rotate: 180deg;">
          </div>
        </div>
      </div>
      <div class="product_drop">
        <img class="remove-button" data-id="${
          x.id
        }" src="https://cdn.shopify.com/s/files/1/0530/3635/1665/files/close_btn.png" alt="">
      </div>
    </div>
`;
  });

  var items = `${itemsLoop}`;
  if (itemsLoop == "") {
    items =
      '<h3 style="text-align: center; font-size: 16px; color: #000000; width: 100%;">CART IS EMPTY</h3>';
  }

  $(".cart_main_container .cart_container").html(items);
  $(".cart-total").html(Shopify.formatMoney(cart.total_price, "£{{amount}}"));
  $(".total-items").html(cart.item_count);
}
var first_load = false;
$(document).on("cart.requestComplete", function (event, cart) {
  // Event handling here..
  console.log(event);
  buildCart(cart);
  if (!$(".cart_main_container").hasClass("active") && first_load) {
    $(".header_elements .cart_wrapper")[0].click();
  }
  first_load = true;
});

$(document).on(
  "click",
  ".cart_main_container .cart_header button, .cart-overlay",
  function (e) {
    e.preventDefault();
    $(".cart_main_container").removeClass("active");
    if ($(".cart_main_container").hasClass('active')) {
      document.querySelector('body').style.overflowY = 'hidden';
    } else {
      document.querySelector('body').style.overflowY = 'auto';
    }
  }
);

//Plus icon function
$(document).on(
  "click",
  ".cart_main_container .cart_container .product_container .product_detail .qty_arrow_cont img.arrow-up",
  function () {
    let orignal_qty = parseInt(
      $(this).closest(".product_detail").find("h3 span").html()
    );
    let new_qty = orignal_qty + 1;
    CartJS.updateItemById($(this).data("id"), new_qty);
  }
);

//Minus icon function
$(document).on(
  "click",
  ".cart_main_container .cart_container .product_container .product_detail .qty_arrow_cont img.arrow-down",
  function () {
    let orignal_qty = parseInt(
      $(this).closest(".product_detail").find("h3 span").html()
    );
    let new_qty = orignal_qty - 1;
    CartJS.updateItemById($(this).data("id"), new_qty);
  }
);

//Remove button function
$(document).on(
  "click",
  ".product_container .product_drop img.remove-button",
  function () {
    let new_qty = 0;
    CartJS.updateItemById($(this).data("id"), new_qty);
  }
);

$(document).ready(function () {
  CartJS.getCart();
  if($(".slider .slide").length > 1){
   $(".slider")[0].slick.refresh();
  }
});



